import CTASection from './CTASection';
import InlineSVG from '../../icons';
import Message from '../message/Message';
import ParallaxWrapper from '../common/ParallaxWrapper';
import PropTypes from 'prop-types';
import React from 'react';
import useIsMobile from './hooks/isMobile';

const HeaderBlock = ({
        data,
        mobile,
        isSubscribed,
        isLoggedIn,
        appImage,
        isGameLaunched,
        ...props
    }) => {
    const {
        cta,
        release,
        subText,
        characters = [],
        background,
        image,
        subTextAvailable
    } = data;
    const isMobile = useIsMobile(mobile);
    const backgroundImage = mobile ? background.mobileImage : background.desktopImage;
    const {launched, info} = isGameLaunched;
    return (
        <section className="header-block" style={{backgroundImage: `url(${backgroundImage})`}}>
            <div className="container-fluid section">
                <div className="row">
                    <div className="col-xs-12 col-sm-6">
                        <div className="characters">
                            {characters.length > 0 ? (
                                    <>
                                    <ParallaxWrapper toRoot kill={isMobile} className="spy-parallax" speed={35}>
                                        <div className="spy" style={{backgroundImage: `url(${characters[1].desktopImage})`}} />
                                    </ParallaxWrapper>
                                    <ParallaxWrapper toRoot kill={isMobile} className="leader-parallax" speed={20}>
                                        <div className="leader" style={{backgroundImage: `url(${characters[0].desktopImage})`}} />
                                    </ParallaxWrapper>
                                    </>
                            ) : null} 
                            {isMobile && image ? (<div className="mobile-characters" style={{backgroundImage: `url(${image.mobileImage})`}} />) : null}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <div className="content text-center">
                            <div className="logos-section">
                                <div className="icons">
                                    <i className="icon-eg" />
                                    <i className="icon-badRobot" />
                                </div>
                                <h6><Message code="epic.common.presents" /></h6>
                            </div>
                            <h1>
                                <InlineSVG name="logo" className="logo" />
                            </h1>
                            {launched ? (
                                <h4 className="blue available">{subTextAvailable}</h4>
                            ) : (
                                <h4 className="blue">{release}</h4>
                            )}
                            {isSubscribed || launched ? null : (<h3>{subText}</h3>)}
                            <CTASection
                                launched={launched}
                                info={info}
                                appImage={appImage}
                                cta={cta}
                                isSubscribed={isSubscribed}
                                isLoggedIn={isLoggedIn}
                                {...props} />
                        </div>
                    </div>
                </div>
            </div>
            <InlineSVG direction="obtuse-left" name="slant" className="diagonal-clip" />
        </section>
    );
};
HeaderBlock.propTypes = {
    data: PropTypes.object,
    mobile: PropTypes.bool,
    isSubscribed: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    history: PropTypes.object,
    appImage: PropTypes.string,
    isGameLaunched: PropTypes.object,
    downloadLink: PropTypes.string
}

export default HeaderBlock;
